import {
  CHANGE_PASSWORD,
	RESET_PASSWORD,
    REQUEST_RESET_PASSWORD,
    CLEAR_RESET_PASSWORD,

	PROMISE_PENDING,
	PROMISE_REJECTED,
	PROMISE_FULFILLED
} from '../constants';
import error from '../utils/error';
import { login } from './authReducer';


const initialState={
    data:{},
    isSubmit:false,
    error:null,

    changePassword: {
      data: null,
      message: null,
      status_code: null,
      isSubmit: false,
      error: null
    }
}

const onResetPassword=(lastState,payload)=>{
    return {...lastState, data:{...payload}, isSubmit:false}
}

const onRequestResetPassword=(lastState,payload)=>{
    return {...lastState,data:{...payload, isFound: true, message:'We already send a link to your mail'}, error:null, isSubmit:false}
}

const onErrorRequestResetPassword = (lastState, payload) => {
    const err = error(payload);
    const { error:{ message, status_code } } = err;
    // if(message === "We can't find a user with that e-mail address." && status_code === 500){
    //     return {
    //         ...lastState,
    //         data: {
    //             isFound: false,
    //             message:'We already send a link to your mail',
    //             status_code: 200
    //         },
    //         isSubmit: false,
    //         error: null
    //     }
    // }
    return onErrorResetPassword(lastState,payload);
}

const onErrorResetPassword=(lastState,payload)=>{
    return {...lastState, isSubmit:false, ...error(payload)}
}

const resetPasswordReducer = (state=initialState,action)=>{
    switch(action.type){
        case `${CHANGE_PASSWORD}${PROMISE_PENDING}`: return {...state, changePassword: {...state.changePassword, isSubmit: true, error: null, status_code: null}};
        case `${CHANGE_PASSWORD}${PROMISE_FULFILLED}`: {
          const { status_code, message, data } = action.payload
          login(data);
          return {...state, changePassword: {data, status_code, message, isSubmit:false, error:null}};       
        }
        case `${CHANGE_PASSWORD}${PROMISE_REJECTED}`: return {...state, changePassword: {...state.changePassword, ...error(action.payload), isSubmit:false}};

        case `${RESET_PASSWORD}${PROMISE_PENDING}`: return {...state, isSubmit:true, error:null};
        case `${RESET_PASSWORD}${PROMISE_FULFILLED}`: return onResetPassword(state,action.payload);
        case `${RESET_PASSWORD}${PROMISE_REJECTED}`: return onErrorResetPassword(state,action.payload);

        case `${REQUEST_RESET_PASSWORD}${PROMISE_PENDING}`: return {...state, isSubmit:true, error:null};
        case `${REQUEST_RESET_PASSWORD}${PROMISE_FULFILLED}`: return onRequestResetPassword(state,action.payload);
        case `${REQUEST_RESET_PASSWORD}${PROMISE_REJECTED}`: return onErrorRequestResetPassword(state,action.payload);
        case CLEAR_RESET_PASSWORD: return initialState
        default: return state;
    }
}
export default resetPasswordReducer;